import { useEffect, useState } from 'react';
import useAxiosInstance from '../../../../../../Utilities/Hooks/useAxiosInstance';
import { CHANGED_INVENTORIES_API } from '../../../../../../Utilities/APIs/APIs';

function ViewChangedInventories({ targetID }) {
  const axiosInstance = useAxiosInstance();

  const [info, setInfo] = useState(null);
  const [codes, setCodes] = useState([]); // list of barcode codes for this change row

  useEffect(() => {
    async function fetchChange() {
      try {
        const { data } = await axiosInstance.get(
          CHANGED_INVENTORIES_API + 'getSingleChangeInventory/' + targetID
        );
        setInfo(data);

        if (Array.isArray(data?.barcodes) && data.barcodes.length > 0) {
          setCodes(data.barcodes);
        } else {
          // fallback: get stock units by change id
          const { data: units } = await axiosInstance.get(
            `/inventory/stockUnits/by-change/${targetID}`
          );
          const list = (units || []).map((u) => u.code);
          setCodes(list);
        }
      } catch {
        setInfo(null);
        setCodes([]);
      }
    }
    fetchChange();
  }, [targetID, axiosInstance]);

  function locationLabel(value) {
    if (value === "mainOffice") return "Main Office";
    if (value === "showRoom") return "Showroom";
    if (value === "wareHouse") return "Warehouse";
    return "—";
  }

  return (
    <div className="crud_view_content">
      {info && (
        <>
          <h1>Quantity</h1>
          <p>{info.quantity}</p>

          <h1>Date</h1>
          <p>{new Date(info?.date).toLocaleDateString()}</p>

          <h1>Change Type</h1>
          <p>{info?.changeType}</p>

          <h1>Location</h1>
          <p>{locationLabel(info?.productLocation)}</p>

          <h1>Start Quantity</h1>
          <p>{info?.startQuantity}</p>

          <h1>End Quantity</h1>
          <p>{info?.endQuantity}</p>

          <div className="barcode-header">
            <h1>Generated Barcodes ({codes.length})</h1>
            {codes.length > 0 && (
              <button className="print-button" onClick={() => window.print()}>
                Print Barcodes
              </button>
            )}
          </div>

          <div className="barcode-list">
            {codes.length === 0 ? (
              <p style={{ opacity: 0.8 }}>No barcodes for this change.</p>
            ) : (
              codes.map((code) => (
                <div key={code} className="barcode-item">
                  <img
                    src={`https://api.stridesco.com/api/public/barcode/${code}.png`}
                    alt={code}
                    draggable={false}
                  />
                  {/* <p className="mono">{code}</p> */}
                </div>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default ViewChangedInventories;